import { ECreateQuestionMode } from 'components/Questionsv2/builder/context/create-question.context';
import { useIsQuestionPublishedOrNonExclusiveQuery } from 'rtk/query/apis/questions';

export const useInTemplateEditAndUneditable = (nodeId: string | undefined, mode: ECreateQuestionMode): boolean => {
  let inTemplateEditAndUneditable = false;
  const { data } = useIsQuestionPublishedOrNonExclusiveQuery({ questionId: nodeId }, { skip: !nodeId });
  if (mode === ECreateQuestionMode.InTemplateEdit) {
    inTemplateEditAndUneditable = data?.isPublishedOrNonExclusiveQuestion ?? true;
  }
  return inTemplateEditAndUneditable;
};
